import { combineActions, handleActions } from 'redux-actions';
import {
    DISMISS_MODAL,
    RESET_ADD_SEARCH_ALERT,
    RESET_ADD_SEARCH_ALERT_ACTION,
    SAVE_SEARCH_REQUEST,
    SAVE_SEARCH_SUCCESS,
} from './actions';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

export interface State {
    readonly submitted: boolean;
    readonly success: boolean;
}

export const DEFAULT_STATE: State = {
    submitted: false,
    success: false,
};

export const reducer = handleActions(
    {
        [combineActions(DISMISS_MODAL, RESET_ADD_SEARCH_ALERT)]: (): State => {
            return DEFAULT_STATE;
        },
        [SAVE_SEARCH_REQUEST]: (state: State) => ({
            ...state,
            submitted: true,
            success: false,
        }),
        [SAVE_SEARCH_SUCCESS]: (state: State) => ({
            ...state,
            submitted: false,
            success: true,
        }),
    },
    DEFAULT_STATE
);

/* SELECTORS */
const stateSelector = (state: GlobalState): State => state.addSearchAlert;

export const addSearchAlertSelector = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const setDefaultAddSearchAlertState = () => async (dispatch: any) => {
    dispatch({
        type: RESET_ADD_SEARCH_ALERT,
    } as RESET_ADD_SEARCH_ALERT_ACTION);
};
